import Swiper from 'swiper';
import { Controller, Autoplay, Navigation } from 'swiper/modules';
import 'swiper/css';
import EA from '../helpers/init';

export default EA.Methods.heroHistorySlider = ($this) => {
    const heroHistoryBackgroundSliderEl = $this.querySelector('.history-swiper-background');
    const heroHistoryContentSliderEl = $this.querySelector('.history-swiper-content');
    const yearRange = $this.querySelector('.year-range');

    function updateProgress(swiper) {
        const current = swiper.realIndex + 1;
        const total = swiper.slides.filter((slide) => {
            return !slide.classList.contains('swiper-slide-duplicate');
        }).length;

        const progress = (current / total) * 100;

        yearRange.style.setProperty('--progress', `${progress}%`);
    }

    const heroHistoryBackgroundSlider = new Swiper(heroHistoryBackgroundSliderEl, {
        modules: [Controller, Autoplay, Navigation],
        speed: 1500,
        slidesPerView: 1,
        loop: true,
        // autoplay: {
        //     delay: 4000,
        //     disableOnInteraction: false,
        // },
        navigation: {
            nextEl: $this.querySelector('.history-swiper-navigation .swiper-button-next'),
            prevEl: $this.querySelector('.history-swiper-navigation .swiper-button-prev'),
        },
        on: {
            afterInit: (swiper) => updateProgress(swiper),
            slideChange: (swiper) => updateProgress(swiper),
        }
    });

    const heroHistoryContentSlider = new Swiper(heroHistoryContentSliderEl, {
        modules: [Controller],
        speed: 1500,
        slidesPerView: 1,
        spaceBetween: 40,
        loop: true,
    });

    heroHistoryBackgroundSlider.controller.control = heroHistoryContentSlider;
    heroHistoryContentSlider.controller.control = heroHistoryBackgroundSlider;
};